import "../css/home.css";
import logo_pattern_fill from "../img/logo_pattern_fill.png";
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();
// import cheatsheet_illustration from "../img/cheatsheet_illustration.png";

const Home = () => {
  return (
    <div>
      {" "}
      <div id="hero">
        <div id="hero_text" data-aos="fade-up">
          <h1>Browse the web on your own terms</h1>
          <div id="hero_copy">
            <h4>
              Navigating the internet can be difficult to navigate when you are
              Neurodivergent. CheatSheet aims to make it a bit more accessible.
            </h4>
            <div id="hero_buttons">
              <a
                class="download_btn"
                href="https://chrome.google.com/webstore/detail/cheatsheet/mgfdddgcpjkoondkodggdigadgjjklgo/related?hl=en&authuser=0"
              >
                Download
              </a>
              <a href="#about_header">Learn more</a>
            </div>
          </div>
        </div>
        <div id="hero_image" data-aos="fade-left">
          <img src={logo_pattern_fill} alt="logo_pattern_fill.png" />
        </div>
      </div>
      <main>
        <div id="about">
          <div id="about_header" data-aos="fade-up">
            <h2>What is CheatSheet?</h2>
            <div id="about_rect"></div>
          </div>
          <div id="about_copy" data-aos="fade-up">
            <p>
              CheatSheet is a free to use, open-source browser extension aimed
              at making navigating the internet easier to neurodivergent
              students. Currently, CheatSheet’s tools cater to users with
              Dyslexia, Dyscalculia and ADHD.
            </p>
            <p>
              The concept for CheatSheet comes from my own experiences as a
              Dyslexic IT student. I have found that much of the documentation I
              have to read through can be poorly formatted with confusing fonts,
              or surrounded by distracting images and advertisements. CheatSheet
              looks to tackle these obstacles, and many more.
            </p>
            <p>
              CheatSheet was developed as part of my final year college project.
              That being said, I plan to continue updating the extension and
              adding new features.
            </p>
          </div>
        </div>
        <div id="data"></div>
        <div id="info">
          <div id="info_header" data-aos="fade-up">
            <h2>What tools do we offer?</h2>
            <div id="info_rect"></div>
          </div>
          <div class="info_row" data-aos="fade-up">
            <div class="info_block_right teal">
              <h3>
                Change your <br /> Page Fonts
              </h3>
              <p>
                Websites can often use ugly and complicated fonts. CheatSheet
                allows you to dynamically update the font being used on your
                current webpage to one that is more accessible.
              </p>
            </div>
            <div class="info_block_left pink">
              <h3>
                Restructure <br /> Text Blocks
              </h3>
              <p>
                Dense blocks of text can ungainly and difficult to read. With
                CheatSheet, you can restructure these confusing text-blocks into
                easy-to-read chunks.
              </p>
            </div>
            <div class="info_block_right blue">
              <h3>
                Remove <br /> Distractions
              </h3>
              <p>
                Distracting images and advertisements can make reading a webpage
                difficult. CheatSheet can get rid of these distractions for you
                dropping their opacity to 40%.
              </p>
            </div>
            <div class="info_block_left teal media_show">
              <h3>
                View Numbers <br />
                as Text
              </h3>
              <p>
                Numbers can often appear long and confusing. With CheatSheet,
                you can highlight numbers in your browser to return their
                written equivalent.
              </p>
            </div>
            <div class="info_block_right purple media_show">
              <h3>
                Enable Sticky <br /> Tabs
              </h3>
              <p>
                It can be easy to lose your place when navigating a website.
                CheatSheet allows you to add sticky tabs to your current webpage
                to save your place.
              </p>
            </div>
            <div class="info_block_left pink media_show">
              <h3>
                More Updates <br /> to Come...
              </h3>
              <p>
                I am continuing to update CheatSheet, with some future features
                including additional font options, personalization functionality
                and more…
              </p>
            </div>
          </div>
          <div class="info_row media_hide" data-aos="fade-up">
            <div class="info_block_left blue">
              <h3>
                View Numbers <br />
                as Text
              </h3>
              <p>
                Numbers can often appear long and confusing. With CheatSheet,
                you can highlight numbers in your browser to return their
                written equivalent.
              </p>
            </div>
            <div class="info_block_right teal">
              <h3>
                Enable Sticky <br /> Tabs
              </h3>
              <p>
                It can be easy to lose your place when navigating a website.
                CheatSheet allows you to add sticky tabs to your current webpage
                to save your place.
              </p>
            </div>
            <div class="info_block_left purple">
              <h3>
                More Updates <br /> to Come...
              </h3>
              <p>
                I am continuing to update CheatSheet, with some future features
                including additional font options, personalization functionality
                and more…
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
